import SuccessfullyForgotPasswordCard from './SuccessfullyForgotPasswordCard'

export default SuccessfullyForgotPasswordCard
